import { ShaderAttr, ShaderBase, ShaderUniforms } from './shader';
import { Context } from '../context/Context';

export abstract class ShaderManagerBase {
  private shaderMap: Map<string, ShaderBase<ShaderUniforms, ShaderAttr>>;

  constructor(public ctx: Context) {
    this.shaderMap = new Map<string, ShaderBase<ShaderUniforms, ShaderAttr>>();
  }

  public get gl(): WebGL2RenderingContext {
    return this.ctx.gl;
  }

  protected getShader(
    reference: string,
    settings: string[],
    factory: () => ShaderBase<ShaderUniforms, ShaderAttr>,
  ): ShaderBase<ShaderUniforms, ShaderAttr> {
    let key = this.generateKey(reference, settings);
    if (!this.shaderMap.has(key)) {
      this.shaderMap.set(key, factory());
    }

    return this.shaderMap.get(key)!;
  }

  private generateKey(reference: string, settings: string[]) {
    return `${reference}:${[...settings].sort().join('/')}`;
  }
}
